export default {
    props: ['title'],
    name: 'TitleHeader',
    data() {
        return {
        };
    },
};